import Subheading from 'components/common/Subheading';
import ToggleButton from 'components/common/ToggleButton';
import { HOME_CHEF } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const Questions = ({ handleMealKitTraitClick, isFamilyLead, visibleMealKitTraits }) => {
  const isHomeChef = useBrand(HOME_CHEF);

  const getQuestionText = () => {
    if (isFamilyLead) {
      return 'What can we help you with?';
    } else if (isHomeChef) {
      return 'What kind of meals are you interested in?';
    } else {
      return 'What are your goals?';
    }
  };

  return (
    <>
      <section data-testid="intro-questions">
        <Subheading className="text-secondary my-4 text-left" brandStylesOverrides="h5">
          {getQuestionText()}
        </Subheading>
        <div className="grid grid-cols-1 gap-2 p-0 bp1:grid-cols-2">
          {visibleMealKitTraits &&
            visibleMealKitTraits
              .filter(({ traitType }) => traitType === 'Cooking Goal' || traitType === 'Experience')
              .map(({ friendlyName, selected, description, icon: Icon }) => {
                return (
                  <ToggleButton
                    key={friendlyName}
                    id={friendlyName}
                    name={friendlyName}
                    handleClick={() => handleMealKitTraitClick({ friendlyName, selected })}
                    selected={selected}
                    role="checkbox"
                    type="refreshToggle"
                    aria-checked={selected}
                    aria-label={friendlyName}
                    className="textMd flex min-h-[72px] flex-row items-center justify-between rounded-2xl px-4 py-3"
                  >
                    <div className="text-left">
                      {friendlyName}
                      {description && <p className="mt-1 font-normal leading-5">{description}</p>}
                    </div>
                    {Icon && (
                      <div className="ml-3 flex-shrink-0">
                        <Icon />
                      </div>
                    )}
                  </ToggleButton>
                );
              })}
        </div>
      </section>
    </>
  );
};

Questions.propTypes = {
  handleMealKitTraitClick: PropTypes.func.isRequired,
  isFamilyLead: PropTypes.bool.isRequired,
  visibleMealKitTraits: PropTypes.array.isRequired,
};

export default Questions;
